export let ExpressCheckoutModalType = /*#__PURE__*/function (ExpressCheckoutModalType) {
  ExpressCheckoutModalType["OwnerNoShipping"] = "ownerNoShipping";
  ExpressCheckoutModalType["BuyerNoShipping"] = "buyerNoShipping";
  ExpressCheckoutModalType["OwnerNoPremium"] = "ownerNoPremium";
  ExpressCheckoutModalType["BuyerNoPremium"] = "buyerNoPremium";
  ExpressCheckoutModalType["PreviewMode"] = "previewMode";
  ExpressCheckoutModalType["TestMode"] = "testMode";
  return ExpressCheckoutModalType;
}({});
export const getExpressCheckoutModalParams = _ref => {
  let modalType = _ref.modalType,
    upgradeUrl = _ref.upgradeUrl,
    shippingSettingsUrl = _ref.shippingSettingsUrl,
    onClose = _ref.onClose;
  switch (modalType) {
    case ExpressCheckoutModalType.OwnerNoShipping:
      return {
        titleKey: 'expressCheckout.alertDialog.physicalProducts.title',
        bodyKey: 'expressCheckout.alertDialog.physicalProducts.description',
        buttonKey: 'expressCheckout.alertDialog.physicalProducts.cta',
        onAction: () => {
          window.open(shippingSettingsUrl, '_blank', 'noopener,noreferrer');
          onClose();
        }
      };
    case ExpressCheckoutModalType.OwnerNoPremium:
      return {
        titleKey: 'expressCheckout.alertDialog.onlinePayments.title',
        bodyKey: 'expressCheckout.alertDialog.onlinePayments.description',
        buttonKey: 'expressCheckout.alertDialog.onlinePayments.cta',
        onAction: () => {
          window.open(upgradeUrl, '_blank', 'noopener,noreferrer');
          onClose();
        }
      };
    case ExpressCheckoutModalType.BuyerNoShipping:
      return {
        titleKey: 'checkout.noShipping.checkoutUnavailable.title',
        bodyKey: 'checkout.noShipping.checkoutUnavailable.body',
        buttonKey: 'checkout.noShipping.checkoutUnavailable.cta',
        onAction: () => onClose()
      };
    case ExpressCheckoutModalType.BuyerNoPremium:
      return {
        titleKey: 'checkout.noPremium.checkoutUnavailable.title',
        bodyKey: 'checkout.noPremium.checkoutUnavailable.body',
        buttonKey: 'checkout.noPremium.checkoutUnavailable.cta',
        onAction: () => onClose()
      };
    case ExpressCheckoutModalType.PreviewMode:
      return {
        titleKey: 'expressCheckout.alertDialog.previewMode.title',
        bodyKey: 'expressCheckout.alertDialog.previewMode.description',
        buttonKey: 'expressCheckout.alertDialog.previewMode.cta',
        onAction: () => onClose()
      };
    case ExpressCheckoutModalType.TestMode:
      return {
        titleKey: 'checkout.testMode.expressCheckoutModal.title',
        bodyKey: 'checkout.testMode.expressCheckoutModal.body',
        buttonKey: 'checkout.testMode.expressCheckoutModal.cta',
        onAction: () => onClose()
      };
    /* istanbul ignore next */
    default:
      {
        const unhandledModalType = modalType;
        throw new Error(`Unexpected express checkout modal type: ${String(unhandledModalType)}`);
      }
  }
};
//# sourceMappingURL=ExpressCheckoutErrorModal.utils.js.map